import { Line, LineChart, ResponsiveContainer, YAxis } from 'recharts';

interface SparklineProps {
  data: Array<{ value: number }>;
  color?: string;
  height?: number;
  reversed?: boolean;
}

export function Sparkline({ data, color = '#4f46e5', height = 36, reversed = false }: SparklineProps) {
  if (data.length < 2) {
    return <div style={{ height }} />;
  }

  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={data}>
        {reversed && <YAxis reversed hide domain={['dataMin', 'dataMax']} />}
        <Line type="monotone" dataKey="value" stroke={color} strokeWidth={2} dot={false} isAnimationActive={false} />
      </LineChart>
    </ResponsiveContainer>
  );
}
